/*
  File: italiansecret-product-modal.js
  Description:
  Global product modal controller that fetches section-rendered content and
  displays it in a custom overlay. Triggers are elements with data-is-product-modal.
*/

(function () {
  var modalRoot;
  var modalContent;
  var lastFocused;

  function getProductUrl(trigger) {
    if (!trigger) return '';
    if (trigger.dataset && trigger.dataset.productUrl) {
      return trigger.dataset.productUrl;
    }
    if (trigger.dataset && trigger.dataset.productHandle) {
      return '/products/' + trigger.dataset.productHandle;
    }
    var card = trigger.closest('[data-product-url]');
    if (card) return card.getAttribute('data-product-url') || '';
    if (trigger.getAttribute) {
      return trigger.getAttribute('href') || '';
    }
    return '';
  }

  function getVariantId(trigger) {
    if (!trigger) return '';
    if (trigger.dataset && trigger.dataset.variantId) {
      return trigger.dataset.variantId;
    }
    var card = trigger.closest('[data-active-variant-id]');
    if (card) return card.getAttribute('data-active-variant-id') || '';
    return '';
  }

  function buildSectionUrl(productUrl, variantId) {
    if (!productUrl) return '';
    var separator = productUrl.indexOf('?') === -1 ? '?' : '&';
    var url = productUrl + separator + 'section_id=italiansecret-product-modal';
    if (variantId) {
      url += '&variant=' + encodeURIComponent(variantId);
    }
    return url;
  }

  function ensureModal() {
    if (modalRoot) return modalRoot;

    modalRoot = document.createElement('div');
    modalRoot.className = 'is-product-modal';
    modalRoot.setAttribute('aria-hidden', 'true');
    modalRoot.innerHTML =
      '<div class="is-product-modal__overlay" data-modal-close></div>' +
      '<div class="is-product-modal__dialog" role="dialog" aria-modal="true">' +
        '<button class="is-product-modal__close" type="button" data-modal-close aria-label="Close modal">' +
          (window.KROWN && window.KROWN.settings && window.KROWN.settings.symbols ? window.KROWN.settings.symbols.close : '&times;') +
        '</button>' +
        '<div class="is-product-modal__body" data-modal-body></div>' +
      '</div>';

    document.body.appendChild(modalRoot);
    modalContent = modalRoot.querySelector('[data-modal-body]');

    modalRoot.addEventListener('click', function (event) {
      var closeTarget = event.target.closest('[data-modal-close]');
      if (closeTarget) {
        event.preventDefault();
        closeModal();
      }
    });

    return modalRoot;
  }

  function openModalWithHtml(html) {
    ensureModal();
    modalContent.innerHTML = html || '';
    modalRoot.classList.add('is-product-modal--open');
    modalRoot.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-product-modal-open');
  }

  function closeModal() {
    if (!modalRoot) return;
    modalRoot.classList.remove('is-product-modal--open');
    modalRoot.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-product-modal-open');
    modalContent.innerHTML = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function fetchModalContent(productUrl, variantId) {
    var sectionUrl = buildSectionUrl(productUrl, variantId);
    if (!sectionUrl) return Promise.resolve('');

    return fetch(sectionUrl, { headers: { Accept: 'text/html' } })
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('.is-product-modal__content');
        return section ? section.innerHTML : text;
      });
  }

  function onTriggerClick(event) {
    var trigger = event.target.closest('[data-is-product-modal]');
    if (!trigger) return;
    if (event.defaultPrevented) return;

    var productUrl = getProductUrl(trigger);
    var variantId = getVariantId(trigger);
    if (!productUrl) return;

    event.preventDefault();
    lastFocused = trigger;

    fetchModalContent(productUrl, variantId)
      .then(function (html) {
        if (!html) return;
        openModalWithHtml(html);
      })
      .catch(function () {});
  }

  function onTriggerKeydown(event) {
    if (event.key !== 'Enter') return;
    var trigger = event.target.closest('[data-is-product-modal]');
    if (!trigger) return;
    event.preventDefault();
    trigger.click();
  }

  document.addEventListener('click', onTriggerClick);
  document.addEventListener('keydown', onTriggerKeydown);
  document.addEventListener('click', function (event) {
    var qtyBtn = event.target.closest('.is-product-modal__qty-btn');
    if (qtyBtn) {
      var purchase = qtyBtn.closest('[data-is-product-modal-purchase]');
      if (!purchase) return;
      var step = Number(qtyBtn.getAttribute('data-qty-step') || 0);
      var valueEl = purchase.querySelector('[data-qty-value]');
      if (!valueEl) return;
      var current = Number(valueEl.textContent) || 1;
      var next = Math.max(1, current + step);
      valueEl.textContent = String(next);
      return;
    }

    var addBtn = event.target.closest('[data-is-product-modal-add]');
    if (addBtn) {
      var purchaseWrap = addBtn.closest('[data-is-product-modal-purchase]');
      if (!purchaseWrap) return;
      var variantId = purchaseWrap.getAttribute('data-variant-id');
      var qtyEl = purchaseWrap.querySelector('[data-qty-value]');
      var qty = qtyEl ? Number(qtyEl.textContent) || 1 : 1;
      if (!variantId) return;

      addBtn.disabled = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var existing = 0;
          (cart.items || []).forEach(function (item) {
            if (String(item.variant_id) === String(variantId)) {
              existing += item.quantity;
            }
          });

          if (existing > 0) {
            var payload = { updates: {} };
            payload.updates[variantId] = existing + qty;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify(payload)
            });
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: qty
            })
          });
        })
        .then(function () {
          if (typeof document !== 'undefined') {
            document.documentElement.dispatchEvent(new CustomEvent('is:cart:updated'));
          }
          // Added by Italian Secret on 2026-01-16
          if (typeof window !== 'undefined') {
            var orderNowPath = '/pages/order-now';
            if (window.location.pathname.indexOf(orderNowPath) === -1) {
              window.location.href = orderNowPath;
              return;
            }
          }
          closeModal();
        })
        .catch(function () {})
        .finally(function () {
          addBtn.disabled = false;
        });
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
})();
